import { render, staticRenderFns } from "./Step1_Identification.vue?vue&type=template&id=1acdb8b1&"
import script from "./Step1_Identification.vue?vue&type=script&lang=js&"
export * from "./Step1_Identification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports